/**
 * @file components/PageContainer Layout组件
 * @author yangxingqiang
 */

import React, {FC} from 'react';
import classnames from 'classnames';

import {ACUD_PRO_PREFIX} from '../../_common/constants';

import PageTitle, {PageTitleProps} from './pageTitle';
import {ProLayout, ProLayoutProps} from './list';
import {ProContainer, ProContainerProps} from './container';

import './index.less';

type PageContainerProps = PageTitleProps & {
    showPageTitle?: boolean; // 是否显示header部分
    mode?: 'card' | 'tabs' | 'tabs-card'; // 如果是card，每个card或section为单独的模块，加边框圆角和白色背景
    children?: React.ReactNode;
}

const PageContainerFn: FC<PageContainerProps> = props => {

    const {showPageTitle = true, mode = '', className, ...pageTitleProps} = props;
    // PageContainer组件通用前缀
    const pageContainerPrefix = `${ACUD_PRO_PREFIX}-page-layout`;

    // 2. 自定义类名
    const prefixClass = classnames(`${pageContainerPrefix}-wrap`, className);
    const contentClass = classnames(`${pageContainerPrefix}-content`, {
        [`${pageContainerPrefix}-card-wrap`]: mode === 'card',
        [`${pageContainerPrefix}-tabs-wrap`]: mode === 'tabs',
        [`${pageContainerPrefix}-card-wrap ${pageContainerPrefix}-tabs-wrap`]: mode === 'tabs-card'
    });

    return (
        <div className={prefixClass}>
            {showPageTitle && <PageTitle
                className={`${pageContainerPrefix}-header`}
                {...pageTitleProps}
            />}
            <div className={contentClass}>
                {props.children}
            </div>
        </div>
    );
};

type PTProps = PageTitleProps & {
    children?: React.ReactNode;
};
type ListProps = ProLayoutProps & {
    children?: React.ReactNode;
};

type DetailProps = ProContainerProps & {
    children?: React.ReactNode;
};

type PageContainerType = typeof PageContainerFn & {
    PageTitle: FC<PTProps>,
    List: FC<ListProps>;
    Detail: FC<DetailProps>;
};

const PageContainer = PageContainerFn as PageContainerType;

// 单独使用PageTitle组件
PageContainer.PageTitle = props => {
    return <PageTitle {...props} />;
};

PageContainer.List = props => {
    return <ProLayout {...props} />;
};

PageContainer.Detail = props => {
    return <ProContainer {...props} />;
};

export default PageContainer;
